module.exports = {
  //Common

  CUR_COMMON__ACADEMICS_YEAR: 'ปีการศึกษา',
  CUR_COMMON__ADD: 'เพิ่ม',
  CUR_COMMON__ADD_SUBDATA: 'เพิ่มข้อมูลย่อย',
  CUR_COMMON__ADDITIONAL: 'เพิ่มเติม',
  CUR_COMMON__ATTACH_FILES: 'แนบไฟล์',
  CUR_COMMON__BACK: 'ย้อนกลับ',
  CUR_COMMON__BRIEF: 'ย่อ',
  CUR_COMMON__CANCEL: 'ยกเลิก',
  CUR_COMMON__CANCEL_EDIT: 'ยกเลิกการแก้ไข',
  CUR_COMMON__CAMPUS: 'สถานที่จัดการเรียนการสอน',
  CUR_COMMON__CATEGORY: 'หมวด',
  CUR_COMMON__CLEAN_UP: 'ล้างข้อมูล',
  CUR_COMMON__CONFIRM: 'ยืนยัน',
  CUR_COMMON__CONFIRM_DELETE_DATA: 'ยืนยันการลบข้อมูล ?',
  CUR_COMMON__CONFIRM_DELETE_DATA_DESC: 'คุณต้องการยืนยันการลบข้อมูล',
  CUR_COMMON__CONFIRM_TRANSACTION: 'ยันยันการทำรายการ',
  CUR_COMMON__CONFIRM_TRANSACTION_DESC: 'คุณต้องการยันยันการทำรายการหรือไม่ ?',
  CUR_COMMON__COPY: 'คัดลอก',
  CUR_COMMON__DATA_NOT_FOUND: 'ไม่พบข้อมูล',
  CUR_COMMON__DECLARATION_OF_USE: 'ประกาศใช้งาน',
  CUR_COMMON__DELETE: 'ลบ',
  CUR_COMMON__DELETE_DATA: 'ลบข้อมูล !',
  CUR_COMMON__DEPARTMENT: 'ภาควิชา',
  CUR_COMMON__DETAILS: 'รายละเอียด',
  CUR_COMMON__DOWNLOAD: 'ดาวน์โหลด',
  CUR_COMMON__EDIT: 'แก้ไข',
  CUR_COMMON__EDIT_SUCCESSFULLY: 'แก้ไขสำเร็จ',
  CUR_COMMON__EDIT_SUCCESSFULLY_DESC: 'บันทึกการแก้ไขข้อมูลรายวิชาสำเร็จ',
  CUR_COMMON__EDUCATION_LEVEL: 'ระดับการศึกษา',
  CUR_COMMON__FACULTY: 'คณะ',
  CUR_COMMON__FILES_SIZE_NO_LARGER_THAN_2MB: 'ขนาดไฟล์ไม่เกิน 2 MB.',
  CUR_COMMON__FILES_TYPE: 'ประเภทไฟล์',
  CUR_COMMON__IMPORT_FILES: 'นำไฟล์เข้า',
  CUR_COMMON__INVALID_DATA: 'ข้อมูลไม่ถูกต้อง กรุณาตรวจสอบอีกครั้ง',
  CUR_COMMON__ITEMS: 'รายการ',
  CUR_COMMON__MAJOR: 'สาขา',
  CUR_COMMON__NEXT: 'ถัดไป',
  CUR_COMMON__OBJECTIVE: 'วัตถุประสงค์',
  CUR_COMMON__OFFER: 'เสนอให้พิจารณา',
  CUR_COMMON__PLEASE_SELECT: 'กรุณาเลือก',
  CUR_COMMON__RESET: 'เริ่มใหม่',
  CUR_COMMON__RECORD_STATUS_ACTIVE: 'ใช้งาน',
  CUR_COMMON__RECORD_STATUS_INACTIVE: 'ไม่ใช้งาน',
  CUR_COMMON__SAVE: 'บันทึก',
  CUR_COMMON__SAVE_SUCCESSFULLY: 'บันทึกสำเร็จ !',
  CUR_COMMON__SEARCH: 'ค้นหา',
  CUR_COMMON__SELECT: 'เลือก',
  CUR_COMMON__SETTING: 'ตั้งค่า',
  CUR_COMMON__SPECIFY_CAMPUS: 'เลือกวิทยาเขต',
  CUR_COMMON__SPECIFY_DEPARTMENT: 'เลือกภาควิชา',
  CUR_COMMON__SPECIFY_EDUCATION_LEVEL: 'เลือกระดับการศึกษา',
  CUR_COMMON__SPECIFY_FACULTY: 'เลือกคณะ',
  CUR_COMMON__SPECIFY_MAJOR: 'เลือกสาขา',
  CUR_COMMON__STATUS: 'สถานะ',
  CUR_COMMON__STATUS_ITEMS: 'สถานะรายการ',
  CUR_COMMON__SUBMENU: 'เมนูย่อย',
  CUR_COMMON__SUBTRACT: 'ลด',
  CUR_COMMON__SUCCESSFUL_STATUS: 'ทำรายการสำเร็จ !',
  CUR_COMMON__SUCCESSFUL_STATUS_DESC: 'คุณทำรายการสำเร็จ',
  CUR_COMMON__SELECT_ALL: ' เลือกทั้งหมด',
  CUR_COMMON__SOMETHING_WRONG: 'มีบางอย่างผิดพลาด !',
  CUR_COMMON__SOMETHING_WRONG_DESC: 'มีบางอย่างผิดพลาด โปรดทำรายการอีกครั้ง.',
  CUR_COMMON__TRASACTION_ALREADY_SAVED: 'บันทึกรายการเรียบร้อยแล้ว',
  CUR_COMMON__TOTAL: 'ทั้งหมด',
  CUR_COMMON__UPDATED_DT: 'วันที่แก้ไขล่าสุด',
  CUR_COMMON__VIEW: 'ดู',

  //Subject
  CUR_SUBJECT_DATA__ADD_SUBJECT: 'เพิ่มรายวิชา',
  CUR_SUBJECT_DATA__APPROVED_DATE: 'วันที่รายวิชาที่ถูกอนุมัติใช้',
  CUR_SUBJECT_DATA__CREDIT: 'จำนวนหน่วยกิต',
  CUR_SUBJECT_DATA__DELETED: 'ลบข้อมูลการจัดการรายวิชาเรียบร้อยแล้ว',
  CUR_SUBJECT_DATA__DIFFRENCE_CREDIT: 'ระบุจำนวนหน่วยกิตและจำนวนครั้ง ที่แตกต่างกันในโครงสร้างรายวิชา',
  CUR_SUBJECT_DATA__MIN_CREDIT: 'หน่วยกิตน้อยที่สุดที่เปิดลงทะเบียน',
  CUR_SUBJECT_DATA__NUMBER_REGISTRATION: 'จำนวนครั้งที่ต้องลงทะเบียน',
  CUR_SUBJECT_DATA__OBJECTIVE: 'วัตถุประสงค์ในการเปิด รายวิชา/ปรับปรุงวิชา',
  CUR_SUBJECT_DATA__STATUS: 'สถานะรายวิชา',
  CUR_SUBJECT_DATA__SHOW_HOUR: 'แสดงหน่วยเป็นชั่วโมง',
  CUR_SUBJECT_DATA__SPLIT_REGISTRATION: 'วิชาที่สามารถแบ่งจำนวน หน่วยกิตเพื่อลงทะเบียนได้',
  CUR_SUBJECT_DATA__START_YEAR: 'ปีที่เปิดใช้รายวิชา',
  CUR_SUBJECT_DATA__SPECIFY_START_YEAR: 'เลือกปีที่เปิดใช้รายวิชา',
  CUR_SUBJECT_DATA__SUBJECT_CATEGORY: 'หมวดวิชา',
  CUR_SUBJECT_DATA__SPECIFY_SUBJECT_CATEGORY: 'เลือกหมวดวิชา',
  CUR_SUBJECT_DATA__SUBJECT_CODE: 'รหัสวิชา',
  CUR_SUBJECT_DATA__SPECIFY_SUBJECT_CODE: 'ระบุรหัสวิชา',
  CUR_SUBJECT_DATA__SUBJECT_DESCRIPTION_EN: 'คำอธิบายรายวิชา (อังกฤษ)',
  CUR_SUBJECT_DATA__SUBJECT_DESCRIPTION_TH: 'คำอธิบายรายวิชา (ไทย)',
  CUR_SUBJECT_DATA__SUBJECT_NAME: 'ชื่อวิชา',
  CUR_SUBJECT_DATA__SUBJECT_NAME_EN: 'ชื่อวิชา (อังกฤษ)',
  CUR_SUBJECT_DATA__SUBJECT_NAME_TH: 'ชื่อวิชา (ไทย)',
  CUR_SUBJECT_DATA__SPECIFY_SUBJECT_NAME_EN: 'ระบุชื่อวิชาเป็นภาษาอังกฤษ',
  CUR_SUBJECT_DATA__SPECIFY_SUBJECT_NAME_TH: 'ระบุชื่อวิชาเป็นภาษาไทย',
  CUR_SUBJECT_DATA__SUBJECT_SHOW_CODE: 'รหัสวิชาที่แสดงในใบรายงานคะแนน (Transcript)',
  CUR_SUBJECT_DATA__SPECIFY_SUBJECT_SHOW_CODE: 'ระบุรหัสวิชาที่แสดง',
  CUR_SUBJECT_DATA__SUBJECT_TYPE: 'ประเภทวิชา',
  CUR_SUBJECT_DATA__SPECIFY_SUBJECT_TYPE: 'เลือกประเภทวิชา',
  CUR_SUBJECT_DATA__TEACHER: 'อาจารย์ผู้รับผิดชอบรายวิชา',
  CUR_SUBJECT_DATA__SPECIFY_TEACHER: 'ระบุรหัส, ชื่อ หรือสกุลอาจารย์',
  CUR_SUBJECT_DATA__TQF_TYPE: 'ประเภทจัดทำหลักสูตร',
  CUR_SUBJECT_DATA__SPECIFY_TQF_TYPE: 'ประเภทจัดทำหลักสูตร',
  CUR_SUBJECT_DATA__SUBJECT_DETAILS: 'รายละเอียดรายวิชา',
  CUR_SUBJECT_DATA__DETERMINE_PRE_CO_HOUR: 'กำหนด PreCo รายวิชา',
  CUR_SUBJECT_DATA__DETERMINE_PRE_CO: 'กำหนดรายวิชา PRE - CO',
  CUR_SUBJECT_DATA__PRE_REQUISTED: 'รายวิชาที่ต้องเรียนก่อน (Pre-requisted)',
  CUR_SUBJECT_DATA__CO_REQUISTED: 'รายวิชาที่ต้องเรียนพร้อมกัน (Co-requisted)',
  CUR_SUBJECT_DATA__DETERMINE_HOUR: 'กำหนดชั่วโมงการสอน  ',
  CUR_SUBJECT_DATA__TEACHING_HOURS_DETAILS: 'รายละเอียดชั่วโมงการสอน',
  CUR_SUBJECT_DATA__ADD_GROUP: 'เพิ่มกลุ่ม',
  CUR_SUBJECT_DATA__DELETE_GROUP: 'ลบกลุ่ม',
  CUR_SUBJECT_DATA__ALERT_PRE_REQUISTED: 'กลุ่มวิชาที่บังคับเรียนมาก่อน ถึงจะสามารถลงทะเบียนเรียนได้',
  CUR_SUBJECT_DATA__ALERT_CO_REQUISTED: 'กลุ่มวิชาที่บังคับเรียนพร้อมกัน ถึงจะสามารถลงทะเบียนเรียนได้',
  CUR_SUBJECT_DATA__ADD_PRE_REQUISTED: 'เพิ่มรายวิชาเรียนก่อน',
  CUR_SUBJECT_DATA__ADD_CO_REQUISTED: 'เพิ่มรายวิชาเรียนพร้อมกัน',
  CUR_SUBJECT_DATA__ADD_TEACHING_HOURS_DETAILS: 'เพิ่มรายละเอียดชั่วโมงการสอน',
  CUR_SUBJECT_DATA__ADD_STRATEGIC_OF_UNIVERSITY: 'เพิ่มเป้าหมายทางยุทธศาสตร์มหาวิทยาลัย',
  CUR_SUBJECT_DATA__TOPIC_DETAILS: 'หัวข้อรายละเอียด',
  CUR_SUBJECT_DATA__THEORETICAL_HOURS: 'จำนวนชั่วโมงทฤษฎี',
  CUR_SUBJECT_DATA__PRACTICAL_HOURS: 'จำนวนชั่วโมงปฏิบัติ  ',
  CUR_SUBJECT_DATA__SPECIFY_DETAILS: 'ระบุรายละเอียด',
  CUR_SUBJECT_DATA__SPECIFY_HOURS: 'ชั่วโมง',
  CUR_SUBJECT_DATA__NO: 'ลำดับ',
  CUR_SUBJECT_DATA__LIST: 'รายการ',
  CUR_SUBJECT_DATA__EXAMINATION_FORMAT: 'รูปแบบการเรียนการตรวจสอบ',
  CUR_SUBJECT_DATA__SPECIFY_FORMAT: 'เลือกรูปแบบ',
  CUR_SUBJECT_DATA__SPECIFY_GOALS: 'เลือกเป้าหมาย',
  CUR_SUBJECT_DATA__STRATEGIC_OF_UNIVERSITY: 'เป้าหมายทางยุทธศาสตร์มหาวิทยาลัย',
  CUR_SUBJECT_DATA__ACHIEVEMENT_GOALS: 'กำหนดเป้าหมายของรายวิชา',
  CUR_SUBJECT_DATA__RESPONSIVE_TO_ACHIEVEMENT: 'รายวิชามีการตอบสนองเพื่อให้บรรลุเป้าหมายตามยุทธศาสตร์การพัฒนามหาวิทยาลัย',
  CUR_SUBJECT_DATA__SPECIFY_CLO: 'ระบุผลการเรียนรู้ที่คาดหวังระดับรายวิชา',
  CUR_SUBJECT_DATA__SPECIFY_PLO: 'ระบุผลการเรียนรู้ที่คาดหวังระดับหลักสูตร',
  CUR_SUBJECT_DATA__SPECIFY_NUMBER: 'ระบุจำนวนเป็นตัวเลข',
  CUR_SUBJECT_DATA__SPECIFY_OBJECTIVE: 'ระบุวัตถุประสงค์ในการเปิดรายวิชา/ปรับปรุงรายวิชา',
  CUR_SUBJECT_DATA__SPECIFY_DESCRIPTION_TH: 'ระบุคำอธิบายรายวิชาเป็นภาษาไทย',
  CUR_SUBJECT_DATA__SPECIFY_DESCRIPTION_EN: 'ระบุคำอธิบายรายวิชาเป็นภาษาอังกฤษ',
  CUR_SUBJECT_DATA__CAN_DEVIDE_CREDIT: 'สามารถแบ่งได้',
  CUR_SUBJECT_DATA__CANT_DEVIDE_CREDIT: 'ไม่สามารถแบ่งได้',
  CUR_SUBJECT_DATA__TITLE: 'ข้อมูลทั่วไปของรายวิชา',
  CUR_SUBJECT_DATA__SPECIFY_SUBJECT: 'ระบุรหัสวิชา/ชื่อวิชา',
  CUR_SUBJECT_DATA__EDIT_INFORMATION: 'แก้ไขข้อมูลเบื้องต้นของรายวิชา ',
  CUR_SUBJECT_DATA__COPY_TITLE: 'ยืนยันรายวิชาที่ต้องการคัดลอก',
  CUR_SUBJECT_DATA__SUBJECTCODE_YEAR: 'รหัสวิชา-ปี',
  CUR_SUBJECT_DATA__SEARCH_RESULTS: 'ผลการค้นหา',
  CUR_SUBJECT_DATA__SELECT_PRE_REQUIST: 'เลือกรายวิชาเรียนก่อน (Pre-requist)',
  CUR_SUBJECT_DATA__SELECT_CO_REQUIST: 'เลือกรายวิชาเรียนร่วม (Co-requist)',
  CUR_SUBJECT_DATA__ENTER_KEYWORD: 'กรุณาใส่ Keyword เพื่อทำการค้นหา!',
  CUR_SUBJECT_DATA__INFORMTION_INCOMPLETE: 'กรอกข้อมูลรายวิชายังไม่สมบูรณ์',
  CUR_SUBJECT_DATA__INFORMTION_INCOMPLETE_DESC: 'คุณต้องการกรอกข้อมูลให้สมบูรณ์ หรือไม่.',
  CUR_SUBJECT_DATA__CREATED_SUCCESSFULLY: 'สร้างรายวิชาสำเร็จ',
  CUR_SUBJECT_DATA__DUPLICATE_SUBJECT_CODE: 'รหัสรายวิชาซ้ำ',
  CUR_SUBJECT_DATA__DUPLICATE_SUBJECT_CODE_DESC: 'รหัสรายวิชาซ้ำ กรุณากรอกรหัสใหม่!',
  // CUR_SUBJECT_DATA__:'',
}
